module.exports = __webpack_public_path__ + "static/media/family.1f6f6fa9.jpg";